import * as React from "react";

export interface Props {
	active: boolean;
	onClick?: React.MouseEventHandler<HTMLButtonElement>;
	disabled?: boolean;
	title: string;
	className?: string;
	innerRef?: React.RefObject<HTMLButtonElement>;
	children?: React.ReactNode;
}

/** An appropriately styled tool button. */
export default function ToolButton(props: Props) {
	return (
		<button
			className={`tool-button ${props.active ? "active" : ""} ${props.className}`}
			aria-pressed={props.active}
			onClick={props.onClick}
			disabled={props.disabled}
			type="button"
			title={props.title}
			ref={props.innerRef}
		>
			{props.children}
		</button>
	);
}
